import { Component } from "@/types/types"
import { cx } from "@/utils/cx"
import * as RadixTooltip from "@radix-ui/react-tooltip"

export const COMPONENT_NAME = "tooltip"

export const presets = {}

export interface Props extends Component {
  label: string
  side?: "left" | "top" | "right" | "bottom" | undefined
  defaultOpen?: boolean
}

export function Tooltip({
  side = "top",
  label,
  children,
  defaultOpen,
  className,
  testId = COMPONENT_NAME,
}: Props) {
  return (
    <RadixTooltip.Provider delayDuration={0}>
      <RadixTooltip.Root defaultOpen={defaultOpen}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Content
          className={cx(
            "h-10 py-3 px-4 text-text-inverse bg-fill-inverse rounded leading-none",
            `data-[state=delayed-open]:animate-fade-in`,
            side === "left" && "origin-right",
            side === "right" && "origin-left",
            side === "top" && "origin-bottom",
            side === "bottom" && "origin-top",
            className,
          )}
          sideOffset={5}
          side={side}
          data-test={testId}
        >
          {label}
          <RadixTooltip.Arrow className="fill-fill-inverse" />
        </RadixTooltip.Content>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  )
}
